import { CommonModule, Location } from "@angular/common";

import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MatBottomSheet, MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatToolbarModule } from "@angular/material/toolbar";

import { Component, Input, ViewChild } from "@angular/core";
import { MatInputModule } from "@angular/material/input";
import { MatTable, MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatSortModule } from "@angular/material/sort";
import { MatTooltipModule } from "@angular/material/tooltip";

import { Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { Building, BuildingStateModel, BuildingUnit, GetBuildings, UpdateBuildingStatus } from 'huddyapi';
import { Select, Store } from "@ngxs/store";
import { Observable, Subscription } from "rxjs";
import { SavedProvider } from "../settings.component";
import { SelectionModel } from "@angular/cdk/collections";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { UnitLog } from "../../components/unit-log/unit-log";





@Component({
  selector: 'buildings',
  standalone: true,
  templateUrl: 'buildings.html',
  styleUrls: ['./buildings.scss'],
  imports : [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatToolbarModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSelectModule,
    MatSortModule,
    MatTooltipModule,
  ]
})
export class Buildings {

  @Input() provider : SavedProvider;
  @Select(state => state.buildingState) buildingState$: Observable<BuildingStateModel>;
  buildingSubscription  : Subscription;
  buildings : Building[] = [];
  allBuildings : Building[] = [];
  sort : string = 'code';
  sortDir : string = 'asc';
  @ViewChild(MatTable) table!: MatTable<any>;
  searchField : string = '';
  executedSearchField : string = '';

  displayedColumns: DisplayedColumn[] =
  [
    { "name" : "select", "displayName" : "Select"},
    { "name": "complex", "displayName": "Complex"},
    { "name": "code", "displayName": "Code" },
    { "name": "status", "displayName": "Status" },
    { "name": "address", "displayName": "Address" },
    { "name": "units", "displayName": "Completed Units" }
  ];
  
  selectedColumns : string[]  =  
  [
    "select",
    "complex", 
    "code",
    "status",
    "address",
    "units"
  ] ;
  public displayColumnsForm : UntypedFormGroup;
  selection = new SelectionModel<Building>(true, []);  
 
  constructor(
    public fb : UntypedFormBuilder,
    public router: Router,
    public dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private store : Store,
    private unitLogBottomSheet: MatBottomSheet
  ) {
    this.displayColumnsForm = this.fb.group({
      selectedColumns: [this.selectedColumns]
     });
    
    this.matIconRegistry.addSvgIcon('search',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/content-icon/ic-02.svg'));


  }
  ngOnInit(): void {

  this.buildingSubscription = this.buildingState$.subscribe((buildingState: BuildingStateModel) => {
      if (buildingState && buildingState.buildings && buildingState.buildings.length > 0) {
        this.allBuildings = buildingState.buildings;
        this.getBuildings();
      }
    });
  this.store.dispatch(new GetBuildings(this.provider.id));
  }


  ngOnDestroy(): void {
    this.buildingSubscription.unsubscribe();
  }

  getUnitsCompleteCount(building : Building) : number {
    if (building.units && building.units != null) {
      return building.units.filter(unit => unit.status === 'COMPLETE').length;
    }
    return 0;
  }




  changeSort($event: any) {
    //this.loading = true;
    this.sort = $event.active;
    this.sortDir = $event.direction;
    this.getBuildings();
  }



  getBuildings() {
   this.buildings = [].concat(this.allBuildings); 
   if (this.searchField && this.searchField.length >= 3) {
    const search = this.searchField.toLocaleLowerCase();
    this.buildings = this.buildings.filter(building => 
      ( building.streetAddress1.toLocaleLowerCase().indexOf(search) >-1 || 
      (''+building.buildingCode).indexOf(search) >-1 ||
      building.complex.toLocaleLowerCase().indexOf(search) >-1 ||
      building.status.toLocaleLowerCase().indexOf(search) > -1 ||
      building.zipCode.indexOf(search) >-1));
   }
   if (this.sort && this.sort.length > 0) {
    //translate sort field to building field
    let sortField = this.sort;
    if (sortField === 'code') {
      sortField = 'buildingCode';
    }
    if (sortField === 'address') {
      sortField = 'streetAddress1';
    }

    this.buildings.sort((a: Building, b: Building) => {
      const keyTypedA = sortField as keyof typeof a;
      const keyTypedB = sortField as keyof typeof a;

      const aValue : string | number | BuildingUnit[] | undefined =  a[keyTypedA];
      const bValue : string | number | BuildingUnit[] |  undefined =  b[keyTypedB] ;

      if (!aValue || !bValue) {
        console.log('no aValue or bValue', aValue, bValue, this.sort);
        return 0;
      }
      if (sortField === 'units') {
        return this.getUnitsCompleteCount(a) - this.getUnitsCompleteCount(b);
      }

      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return aValue - bValue;
      }
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return aValue.localeCompare(bValue);
      }
     
      return 0;
    
    });
    if (this.sortDir && this.sortDir === 'desc') {
      this.buildings = this.buildings.reverse();
    }
    console.log('this.buildings', this.buildings);
    this.table.renderRows();
   }
  }


  search($event: any) {

    console.log($event,this.searchField, $event.target.value);
    this.executedSearchField = this.searchField;
    this.getBuildings();
  } 

  clearSearchField() {
    this.searchField = '';
    this.executedSearchField = '';
    this.buildings = [].concat(this.allBuildings);
  }



  setSearchField($event: any) {
    this.searchField = $event.target.value
  } 
  
  checkSearchValue() {
    this.searchField = this.searchField.replace(/[^a-zA-Z0-9 '-.]/g, '');
  }


  showUnits() {
    let data = {
      building: this.selection.selected[0]
    }

    this.unitLogBottomSheet.open(UnitLog, {
            data: data
          });
  }

  canShowUnits() {
    return this.selection.selected.length == 1 && this.selection.selected[0].status != 'INACTIVE' && this.selection.selected[0].units && this.selection.selected[0].units.length > 0;
  }

  canChangeStatus(from : string) {
  
    const selectedLen : number = this.selection.selected.length;
    const inactiveLen : number = this.selection.selected.filter(t => t.status == from).length;
    return selectedLen > 0 && selectedLen == inactiveLen;
  }

  changeStatus(to : string) {
    for (let building of this.selection.selected) {
      this.store.dispatch(new UpdateBuildingStatus({
        providerId : this.provider.id,
        buildingCode : +building.buildingCode,
        status: to
      }));
    }
    this.selection.clear();
  }


}

export interface DisplayedColumn {
  displayName : string;
  name : string;
}